import { RESULTS_SCREEN } from 'constants/screens';

import React, { useRef, useState } from 'react';

import { Button, FlashCards, Instructions } from '@coursera/components';

import { cards } from '../data/card-data';
import { useAppContext, SET_ACTIVE_SCREEN, START_OVER } from '../store';

import styles from './card-container.module.scss';

function CardContainer() {
  const [isCompleted, setIsCompleted] = useState(false);
  const flashCardRef = useRef();

  const { dispatch } = useAppContext();
  const next = () => dispatch({ type: SET_ACTIVE_SCREEN, payload: RESULTS_SCREEN });

  const startOver = () => {
    setIsCompleted(false);
    flashCardRef.current.triggerShuffle();
    dispatch({ type: START_OVER });
  };

  return (
    <section className={styles.background}>
      <section className={styles.container}>
        <div className={styles.left}>
          <Instructions
            title="Explore where to source interview participants"
            desc={
              <>
                Review the description on each flash card. Guess the name of the source, then select{' '}
                <b>Flip</b> to find out if you’re right. Be sure to review all seven cards.
              </>
            }
            mTitle="Explore where to source participants"
          />
        </div>
        <div className={styles.right}>
          <section className={styles.cards}>
            <FlashCards
              ref={flashCardRef}
              data={cards}
              sectionOrder={['front', 'back1', 'back2']}
              onComplete={() => {
                setIsCompleted(true);
              }}
            />
          </section>
        </div>
      </section>
      <Button.Container fixed hidden={!isCompleted}>
        <Button variant="secondary" onClick={startOver}>
          Shuffle and start over
        </Button>
        <Button onClick={next}>Continue</Button>
      </Button.Container>
    </section>
  );
}

export default CardContainer;
